import React, { createContext, useState } from 'react';

interface LogoContextData {
  logo: any;
  setLogo: React.Dispatch<React.SetStateAction<any>>;
}

export const LogoContext = createContext<LogoContextData>({
  logo: null,
  setLogo: () => {},
});

export const LogoProvider: React.FC = ({ children }) => {
  const [logo, setLogo] = useState<any>(null);

  return (
    <LogoContext.Provider value={{ logo, setLogo }}>
      {children}
    </LogoContext.Provider>
  );
};